export const UPDATE_BOOKING_EXPERIENCE_CONTACT_API_ENDPOINT = '/booking-portal/ContactV2/UpdateContact';
